import { render, staticRenderFns } from "./CertificateInfoGeneral.vue?vue&type=template&id=4697b396&"
import script from "./CertificateInfoGeneral.vue?vue&type=script&lang=js&"
export * from "./CertificateInfoGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports